import { render, staticRenderFns } from "./RideitInvitationCard.vue?vue&type=template&id=55fc4a10&scoped=true"
import script from "./RideitInvitationCard.vue?vue&type=script&lang=ts"
export * from "./RideitInvitationCard.vue?vue&type=script&lang=ts"
import style0 from "./RideitInvitationCard.vue?vue&type=style&index=0&id=55fc4a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc4a10",
  null
  
)

export default component.exports